import React from "react";

const Input = ({ className, textColor, ...props }) => (
  <textarea
    data-testId="TextArea-testSelector"
    className={`bg-transparent outline-none w-full ${className}`}
    style={{ color: textColor }}
    {...props}
  />
);

Input.defaultProps = {
  className: "",
  textColor: ""
};

export default Input;
